<template>
  <div>
    <div
      v-if="current.is_show !== 0"
      class="level_two_item view-flex view-flex-vertical"
    >
      <div class="name">
        <span :class="`iconfont ${current.icon ? current.icon : 'icon-xitongshouye2'}`" />
        {{ current.name }}
      </div>
      <div class="childrens view-flex">
        <template v-for="(child, index) in current.children">
          <div
            v-if="child.is_show !== 0"
            :key="index"
            class="children"
            :class="{ 'is-active': isActive(child) }"
            @click="handleRoute(child.url)"
          >
            <span class="block">
              {{ child.name }}
            </span>
          </div>
        </template>
      </div>
    </div>
    <SplitLine v-if="current.is_show !== 0 && !isLast" />
  </div>
</template>

<script>
import SplitLine from './splitLine'
export default {
  components: {
    SplitLine
  },
  props: {
    current: {
      type: Object
    },
    isLast: {
      type: Boolean
    }
  },
  methods: {
    isActive (child) {
      // console.log(this.filterEdit(this.$route.path))
      return this.filterEdit(this.$route.path) === child.url
    },
    filterEdit (str) {
      const hasId = /[0-9]/.test(str)
      const hasAddOrEdit = /(Add|Edit)/.test(str)
      const hasDetail = /detail/.test(str)
      const splitArr = str.split('/')
      //路径有id 和 Add/Edit并存
      if (hasId && hasAddOrEdit) {
        return splitArr
          .slice(0, splitArr.length - 1)
          .map((item) => {
            if (/(Add|Edit)/.test(item)) {
              return item.replace(/(Add|Edit)/, '')
            }
            return item
          })
          .join('/')
        //路径有id 并且没有 Add/Edit
      } else if (hasId && !hasAddOrEdit) {
        return splitArr.slice(0, splitArr.length - 1).join('/')
        //路径有id 并且没有 Add/Edit
      } else if (hasAddOrEdit && !hasId) {
        return splitArr
          .slice(0, splitArr.length)
          .map((item) => {
            if (/(Add|Edit)/.test(item)) {
              return item.replace(/(Add|Edit)/, '')
            }
            return item
          })
          .join('/')
      }
      return str
    },
    handleRoute (url) {
      if (url) {
        this.$router.push(url)
      }
    }
  }
}
</script>

<style scoped lang="scss">
$text-color: rgba(255, 255, 255, 0.8);
$active-color: #1480e3;
$active-text-color: #fff;

.level_two_item {
  @include menuTextColor();
  padding-left: 16px;

  .iconfont {
    font-size: 14px;
    margin-right: 12px;
  }

  .name {
    height: 40px;
    line-height: 40px;
    width: 100%;
    flex-grow: 0;
    cursor: pointer;
    flex-shrink: 0;
    transition: all 0.3s;
  }

  width: 100%;

  .childrens {
    flex-wrap: wrap;
    margin-left: -10px;

    .children {
      height: 40px;
      line-height: 40px;
      color: $text-color;
      cursor: pointer;
      position: relative;
      width: 50%;

      &:nth-child(2n) {
        padding-left: 10px;
      }

      &:hover {
        .block {
          position: relative;
          &:after {
            position: absolute;
            content: '';
            display: block;
            left: 0;
            right: 0;
            bottom: 0;
            height: 2px;
            background: #1890ff;
          }
        }
      }

      &.is-active {
        .block {
          background: #1890ff;
          color: $active-text-color;
        }
      }

      .block {
        height: 28px;
        border-radius: 2px;
        transition: all 0.3s;
        @include menuTextColor();
        padding: 2px 4px;
        color: rgba(255, 255, 255, 0.7);

        a {
          color: currentColor;
        }
      }

      &:nth-child(2n + 1) {
        span {
          margin-left: 34px;
        }
      }
    }
  }
}
</style>
